<template>
  <div class="page-left pl1" v-if="!isTripartite">
    <div :class="['title',isThree ? 'no-bg' : '']">{{$t('Layout-WorkbenchNavGuild0') || '个人中心'}}</div>
    <router-link :class="{'current' : 'workbench-workbench' == current}" :to="{name:'workbench-workbench'}" class="workbench">{{$t('Layout-TopNav1') || '工作台'}}</router-link>
    <router-link :class="{'current' : societySettingCheck}" :to="{name:'workbench-mysociety'}" class="mysociety">{{$t('guild-GuildComponents-Head11') || '我的公会'}}</router-link>
    <router-link v-if="!isPrivate" :class="{'current' : teamCheck}" :to="{name:'workbench-myteam'}" class="mysociety">{{$t('Layout-WorkbenchNavGuild3') || '我的团队'}}</router-link>
    <router-link :class="{'current' : 'workbench-mytask' == current || 'workbench-applylist' == current}" :to="{name:'workbench-mytask'}" class="mytask">{{$t('Layout-SiderNav1') || '我的任务'}}</router-link>
    <router-link :class="{'current' : taskEfficiencyCheck}" :to="{name:'workbench-taskefficiency-task-details'}" class="mytask">{{$t('Layout-WorkbenchNavGuild8') || '任务质效'}}</router-link>
    <router-link :class="{'current' : 'workbench-exercisemedal' == current}" :to="{name:'workbench-exercisemedal'}" class="exercisemedal">{{$t('guild-Tag-tagDetail29') || '练习与勋章'}}</router-link>
    <router-link :class="{'current' : intergralCheck}" :to="{name:'workbench-myintegral'}" class="myintegral">{{$t('Layout-SiderNav3') || '我的积分'}}</router-link>
    <router-link :class="{'current' : accountSettingCheck}" :to="{name:'workbench-accountsetting'}" class="accountsetting">{{$t('Layout-WorkbenchNavGuild7') || '账号设置'}}</router-link>
<!--    <router-link v-if='ids.includes(userInfo.account)' :class="{'current' : accountSettingCheck}" :to="{name:'workbench-export'}" class="accountsetting">{{'任务管理模块'}}</router-link>-->
    <router-link :class="{'current' : 'workbench-qaassistant' == current}" :to="{name:'workbench-qaassistant'}" class="qaassistant">答疑助手</router-link>
  </div>
  <div class="page-left pl2" v-else>
    <router-link :class="{'current' : 'mysociety-societyDetail' == current}" :to="{name:'mysociety-societyDetail'}" class="workbench">{{$t('Layout-BreadCrumbs1') || '首页'}}</router-link>
    <router-link :class="{'current' : 'workbench-mytask' == current}" :to="{name:'workbench-mytask'}" class="mysociety">{{$t('Layout-SiderNav1') || '我的任务'}}</router-link>
    <router-link :class="{'current' : taskEfficiencyCheck}" :to="{name:'workbench-taskefficiency-task-details'}" class="mytask">{{$t('Layout-WorkbenchNavGuild8') || '任务质效'}}</router-link>
    <router-link :class="{'current' : 'workbench-exercisemedal' == current}" :to="{name:'workbench-exercisemedal'}" class="exercisemedal">{{$t('guild-Tag-tagDetail29') || '练习与勋章'}}</router-link>
    <router-link v-if='ids.includes(userInfo.account)' :class="{'current' : accountSettingCheck}" :to="{name:'workbench-export'}" class="accountsetting">{{'任务管理模块'}}</router-link>
    <router-link :class="{'current' : 'workbench-qaassistant' == current}" :to="{name:'workbench-qaassistant'}" class="qaassistant">答疑助手</router-link>
    <div>
      <div class="title">教辅验收</div>
      <!-- <router-link :class="{'current' : 'workbench-BatchAcceptance' == current}" :to="{name:'workbench-BatchAcceptance'}" class="mytask">{{$t('guild-Tag-tagDetail100') || '答案清洗验收'}}</router-link>
      <router-link :class="{'current' : 'workbench-AcceptRecords' == current}" :to="{name:'workbench-AcceptRecords'}" class="mytask">{{$t('guild-Tag-tagDetail101') || '个人验收记录'}}</router-link> -->
      <router-link :class="{'current' : 'LiveVideoTask2.0' == current}" :to="{name:'LiveVideoTask2.0'}" class="mytask">真人视频2.0</router-link>
      <router-link :class="{'current' : 'LiveVideoAcceptTask2.0' == current}" :to="{name:'LiveVideoAcceptTask2.0'}" class="mytask">真人视频验收2.0</router-link>
      <router-link :class="{'current' : 'workbench-BatchAcceptance-v3' == current}" :to="{name:'workbench-BatchAcceptance-v3'}" class="mytask">答案清洗验收3.0</router-link>
      <router-link :class="{'current' : 'workbench-AcceptRecords-v3' == current}" :to="{name:'workbench-AcceptRecords-v3'}" class="mytask">个人验收记录3.0</router-link>
      <!-- <router-link :class="{'current' : 'workbench-QR-TaskAcceptance' == current}" :to="{name:'workbench-QR-TaskAcceptance'}" class="mytask">快修验收</router-link>
      <router-link :class="{'current' : 'workbench-QR-PersonalAcceptRecords' == current}" :to="{name:'workbench-QR-PersonalAcceptRecords'}" class="mytask">快修个人验收记录</router-link> -->
      <router-link :class="{'current' : 'workbench-QR-TaskAcceptance2' == current}" :to="{name:'workbench-QR-TaskAcceptance2'}" class="mytask">快修验收2.0</router-link>
      <router-link :class="{'current' : 'workbench-QR-PersonalAcceptRecords2' == current}" :to="{name:'workbench-QR-PersonalAcceptRecords2'}" class="mytask">快修个人验收记录2.0</router-link>
      <router-link :class="{'current' : 'workbench-VideoRecordTask' == current}" :to="{name:'workbench-VideoRecordTask'}" class="mytask">视频录制</router-link>
      <router-link :class="{'current' : 'workbench-VideoRecordQualityCheckTask' == current}" :to="{name:'workbench-VideoRecordQualityCheckTask'}" class="mytask">视频录制质检</router-link>
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
      isThree: this.$store.state.app.isTripartite,
      current: '',
      accountSettingCheck: false,
      societySettingCheck: false,
      intergralCheck: false,
      teamCheck: false,
      taskEfficiencyCheck: false,
      userInfo: {},
      ids: ['17805592786', '13666666123', '18256910242', '19965468399', 'king@qq.com', '13856567536']
    }
  },
  props: ['isTripartite', 'isPrivate'],
  computed: {
  },
  watch: {
    $route (to, from) {
      console.log('[WorkbenchNavGuild]>>$route>>to:', to)
      this.current = to.name;
      if (this.current.indexOf('accountsetting') > -1) {
        this.accountSettingCheck = true;
      } else {
        this.accountSettingCheck = false;
      };
      if (this.current.indexOf('mysociety') > -1) {
        this.societySettingCheck = true;
      } else {
        this.societySettingCheck = false;
      };
      if (this.current.indexOf('myintegral') > -1) {
        this.intergralCheck = true;
      } else {
        this.intergralCheck = false;
      }
      if (this.current.indexOf('myteam') > -1) {
        this.teamCheck = true;
      } else {
        this.teamCheck = false;
      }
      if (this.current.indexOf('taskefficiency') > -1) {
        this.taskEfficiencyCheck = true;
      } else {
        this.taskEfficiencyCheck = false;
      }
    }
  },

  methods: {

  },
  created () {
    const userInfo = window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')) : {}
    this.userInfo = userInfo
  },

  mounted () {
    this.current = this.$route.name;
    if (this.current.indexOf('accountsetting') > -1) {
      this.accountSettingCheck = true;
    } else {
      this.accountSettingCheck = false;
    };
    if (this.current.indexOf('mysociety') > -1) {
      this.societySettingCheck = true;
    } else {
      this.societySettingCheck = false;
    };
    if (this.current.indexOf('myintegral') > -1) {
      this.intergralCheck = true;
    } else {
      this.intergralCheck = false;
    }
    if (this.current.indexOf('myteam') > -1) {
      this.teamCheck = true;
    } else {
      this.teamCheck = false;
    }
    if (this.current.indexOf('taskefficiency') > -1) {
      this.taskEfficiencyCheck = true;
    } else {
      this.taskEfficiencyCheck = false;
    }
  }
};
</script>

<style lang="less" scoped>
  @import "../../assets/theme/themeBlue.less";
  .page-left {
    line-height: 40px;
    width: 200px;
    text-align: left;
    background: #fff;
    //height: 70vh;
    //overflow-y: auto;
    a,.title{
      display:flex;
      flex-direction: column;
      border-bottom: 1px dashed #DEDEDE;
      line-height: 52px;
      color: #494949;
      padding-left: 50px;
      font-size: 14px;
      position: relative;
    }
    .title{
      border:0;
      font-size: 16px;
      font-weight: bold;
      color:#18CA6C;
      background: url(../../assets/images/workbench/bg.png) no-repeat 0 0;
      width: 200px;
    }
    .no-bg{
      background: none;
      border-bottom: 1px solid #ccc;
    }
    a:last-child{
      border:0;
    }
    a.current,a:hover{
      color:#18CA6C
    }
    a::before{
      position: absolute;
      width: 16px;
      height: 17px;
      display: block;
      content: '';
      left:25px;
      top: 18px;
    }
    a.accountsetting::before{
      background: url(../../assets/images/workbench/accountsetting.png) no-repeat center center;
    }
    a.workbench::before{
      background: url(../../assets/images/workbench/workbench.png) no-repeat center center;
    }
    a.mytask::before{
      background: url(../../assets/images/workbench/mytask.png) no-repeat center center;
    }
    a.mysociety::before{
      background: url(../../assets/images/workbench/mysociety.png) no-repeat center center;
    }
    a.exercisemedal::before{
      background: url(../../assets/images/workbench/exercisemedal.png) no-repeat center center;
    }
    a.myintegral::before{
      background: url(../../assets/images/workbench/myintegral.png) no-repeat center center;
    }
    a.accountsetting.current::before,a.accountsetting:hover::before{
      background: url(../../assets/images/workbench/accountsetting-i.png) no-repeat center center;
    }
    a.workbench.current::before,a.workbench:hover::before{
      background: url(../../assets/images/workbench/workbench-i.png) no-repeat center center;
    }
    a.mytask.current::before,a.mytask:hover::before{
      background: url(../../assets/images/workbench/mytask-i.png) no-repeat center center;
    }
    a.exercisemedal.current::before,a.exercisemedal:hover::before{
      background: url(../../assets/images/workbench/exercisemedal-i.png) no-repeat center center;
    }
    a.myintegral.current::before,a.myintegral:hover::before{
      background: url(../../assets/images/workbench/myintegral-i.png) no-repeat center center;
    }
    a.mysociety.current::before,a.mysociety:hover::before{
      background: url(../../assets/images/workbench/mysociety-i.png) no-repeat center center;
    }
    a.qaassistant::before{
      background: url(../../assets/images/workbench/accountsetting.png) no-repeat center center;
    }
    a.qaassistant.current::before,a.qaassistant:hover::before{
      background: url(../../assets/images/workbench/accountsetting-i.png) no-repeat center center;
    }
  }
</style>
